import clsx from "clsx";
import { Tooltip } from "flowbite-react";
import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

type ScoreBallsProps = {
  value: number;
  type: "semantics" | "articulation";
};

const ScoreBalls = ({ value, type }: ScoreBallsProps) => {
  const { t } = useTranslation(["songs"]);

  const difficulty = useMemo(() => {
    if (value <= 2.2) {
      return 1;
    } else if (value <= 2.7) {
      return 2;
    } else {
      return 3;
    }
  }, [value]);

  const bgClass = useCallback(
    (number: number) => {
      if (type === "semantics") {
        switch (number) {
          case 1:
            return "bg-primary-orange-600/30";
          case 2:
            return "bg-primary-orange-600/65";
          case 3:
            return "bg-primary-orange-600";
        }
      } else if (type === "articulation") {
        switch (number) {
          case 1:
            return "bg-primary-green-600/30";
          case 2:
            return "bg-primary-green-600/65";
          case 3:
            return "bg-primary-green-600";
        }
      }
    },
    [type],
  );

  return (
    <Tooltip content={t(`${type}.${difficulty}`)}>
      <div className="flex flex-col-reverse items-end h-full">
        {Array.from({ length: difficulty }).map((_, index) => (
          <div
            key={index}
            className={clsx("size-3.5 rounded-full border", bgClass(index + 1))}
          />
        ))}
      </div>
    </Tooltip>
  );
};

export default ScoreBalls;
